<div class="DocInfo">
  <time class="Date">{{ versionDoc.publicationDate }}</time>
  <p class="Version">{{ versionDoc.uniqueNumber }}</p>
  <p class="Author">{{ versionDoc.creator }}</p>
</div>
<p>{{ versionDoc.teaserSummary }}</p>
<button [routerLink]="['../'+versionDoc.uniqueNumber]" [queryParams]="{ version: 'this'}" (click)="onOtherVersionClicked()" class="Button">{{getOtherVersionDisplayMessage()}}</button>
